import * as UserSettingsActions from './user-settings.actions';

export interface State {
  userSettings: GlobalUserSettingDto[];
}

/**
 * The reducer acts on actions as defined below, and is the only way to update state.
 *
 * @param {State} state: the initial state of the redux sub-store
 * @param {UserAction} action: the actions that this sub-store is managing
 * @returns {any} updated state of the redux sub-store
 */
export function userSettingsReducer(state: State = {
  userSettings: undefined
},
action: UserSettingsActions.UserSettingsAction) {
  switch (action.type) {
  case UserSettingsActions.UPDATED_USER_SETTINGS:
    return {
      ...state,
      userSettings: action.payload // update our stored userSettings with the action's payload
    };
  default:
    return state;
  }
}
